import React from "react";
import { Box, Flex, Text, Button, IconButton, Select } from "components-lib";
import { MdWifi } from "react-icons/md";

/**
 * BottomActionBar Component
 * 
 * Fixed bottom bar containing network status, sync status, language selection,
 * and end consultation button
 */
const BottomActionBar = ({
  selectedLanguage, onLanguageChange,
  onEndConsultation
}) => {
  return (
    <Box
      position="fixed"
      bottom="0"
      left="0"
      right="0"
      px={{ base: "16px", md: "24px" }}
      py="16px"
      bg="white"
      borderTop="2px solid"
      borderColor="gray.200"
      boxShadow="0 -2px 10px rgba(0,0,0,0.1)"
      zIndex="1000"
    >
      <Flex justifyContent="space-between" alignItems="center" gap={16} flexWrap="column" md={{ flexWrap: "nowrap" }}>
        {/* Network Status */}
        <Flex alignItems="center" gap={4}>
          <IconButton
            icon={<MdWifi />}
            aria-label="WiFi"
            fontSize="24px"
            variant="ghost"
            size="sm"
          />
          <Text fontSize="sm"  fontWeight="medium">NET-SPPED</Text>
        </Flex>

        {/* Sync Status */}
        <Text color="green.500" fontSize="sm" fontWeight="semibold">Synched 40%</Text>

        {/* Language Selection */}
        {/* <Select
          placeholder="Preferred Language"
          w="180px"
          value={selectedLanguage ?? ""}
          onChange={(e) => onLanguageChange && onLanguageChange(e.target.value)}
          aria-label="Preferred Language"
          size="md"
          borderRadius="md"
        >
          {[
            { value: "english", label: "English" },
            { value: "hindi", label: "Hindi" },
            { value: "bengali", label: "Bengali" },
            { value: "marathi", label: "Marathi" },
            { value: "telugu", label: "Telugu" },
            { value: "tamil", label: "Tamil" },
            { value: "gujarati", label: "Gujarati" },
            { value: "assamese", label: "Assamese" },
            { value: "kannada", label: "Kannada" },
            { value: "malayalam", label: "Malayalam" },
            { value: "punjabi", label: "Punjabi" },
          ].map((lang) => (
            <option
              onSelect={}
              key={lang.value} value={lang.value}>
              {lang.label}
            </option>
          ))}
        </Select> */}

        <Text fontSize="sm" fontWeight="medium">Language: {selectedLanguage}</Text>

        {/* End Consultation Button */}
        <Button
          colorScheme="red"
          size="md"
          fontWeight="bold"
          px={8}
          className="px-5 py-3"
          borderRadius="lg"
          onClick={onEndConsultation}
          _hover={{ transform: "translateY(-1px)", boxShadow: "md" }}
          transition="all 0.2s"
        >
          {" "}End Consultation{" "}
        </Button>
      </Flex>
    </Box>
  );
};

export default BottomActionBar;